// removed by extract-text-webpack-plugin
module.exports = {"container":"_2s5Zo4fgOzp03J7igrJeeg"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/Main/style/TabHeader.pcss
// module id = 1004
// module chunks = 0